import { render } from "./recentMessage.vue?vue&type=template&id=47770255"
import script from "./recentMessage.vue?vue&type=script&lang=js"
export * from "./recentMessage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__